<template>
  <custom-dialog
    :title="
      row._id
        ? `Edit ${typeMapping[form._type]}`
        : `Create ${typeMapping[form._type]}`
    "
  >
    <template v-if="!hasNextPage">
      <el-form
        ref="ruleForm"
        :model="form"
        label-position="left"
        label-width="160px"
      >
        <el-form-item
          label="Advertiser"
          prop="advertiser"
          :rules="stringRule('advertiser')"
        >
          <el-select
            v-model="form.advertiser"
            @change="form.campaign = null"
            clearable
            popper-class="select-advertiser"
          >
            <el-option
              v-for="opt in advertiserOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
              :disabled="!opt.icon && disabledWithCreativeType"
            >
              <span class="option">
                <el-avatar v-if="opt.icon" :size="avatarSize" :fit="'fit'">
                  <img
                    :src="opt.icon"
                    :width="avatarSize"
                    :height="avatarSize"
                  />
                </el-avatar>
                <el-avatar
                  v-else
                  :size="avatarSize"
                  icon="el-icon-user-solid"
                  :fit="'scale-down'"
                >
                </el-avatar>
                <span class="option-label"> {{ opt.label }} </span>
                <span
                  v-if="!opt.icon && disabledWithCreativeType"
                  class="option-end"
                >
                  No Icon Available
                </span>
              </span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="Campaign"
          prop="campaign"
          :rules="stringRule('campaign')"
        >
          <el-select
            v-model="form.campaign"
            clearable
            :disabled="!form.advertiser"
          >
            <el-option
              v-for="opt in campaignOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Name" prop="name" :rules="stringRule('name')">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item
          v-if="
            [
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.INSKIN,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.OUTSTREAM,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PUSHDOWN,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PUSHDOWN_WITH_OUTSTREAM,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PARALLAX_SCROLLING,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY
                .PARALLAX_SCROLLING_WITH_OUTSTREAM,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PARALLAX_SCROLLING_FLIP,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER_WITH_OUTSTREAM,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.MARQUEE,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.COUNT_DOWN,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.VAST,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD_WITH_OUTSTREAM,
            ].includes(form._type)
          "
          label="Landing Page"
          prop="landing_page"
          :rules="
            urlRule(
              'landing_page',
              form._type != CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.OUTSTREAM
            )
          "
        >
          <el-input v-model="form.landing_page"></el-input>
        </el-form-item>

        <el-form-item
          label="Preview Type"
          prop="preview_type"
          :rules="optionRule('preview_type', previewOptions)"
          v-if="previewOptions.length"
        >
          <el-select v-model="form.preview_type">
            <el-option
              v-for="opt in previewOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Preview Mode" v-if="previewOptions.length">
          <el-radio-group text-color="#EF767A" v-model="form.preview_device">
            <el-radio-button :label="CONSTANT.PREVIEW_DEVICE.PC"
              >PC</el-radio-button
            >
            <el-radio-button :label="CONSTANT.PREVIEW_DEVICE.MOBILE"
              >MOBILE</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <component
          ref="typeField"
          :is="_.upperFirst(form._type + 'Form').replace('WithOutstream', '')"
          v-model="form"
        ></component>

        <template
          v-if="form._type !== CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.VAST"
        >
          <el-divider>
            <span class="blue">Base Trackings</span>
          </el-divider>
          <form-item-group
            title="Impression Trackings"
            :min="0"
            :max="5"
            v-model="form.impression_trackings"
          >
            <template slot-scope="{ index }">
              <el-form-item
                label="impression"
                :prop="`impression_trackings.${index}`"
                :rules="urlRule('impression_tracking')"
                label-width="120px"
              >
                <el-input v-model="form.impression_trackings[index]"></el-input>
              </el-form-item>
            </template>
          </form-item-group>

          <form-item-group
            title="Click Trackings"
            :min="0"
            :max="5"
            v-model="form.click_trackings"
          >
            <template slot-scope="{ index }">
              <el-form-item
                label="click"
                :prop="`click_trackings.${index}`"
                :rules="urlRule('click_trackings')"
                label-width="120px"
              >
                <el-input v-model="form.click_trackings[index]"></el-input>
              </el-form-item>
            </template>
          </form-item-group>

          <el-form-item label="Audience" prop="audience">
            <el-select v-model="form.audience" multiple clearable>
              <el-option
                v-for="opt in audienceOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              >
                <span style="float: left">{{ opt.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px"
                  >size: {{ opt.size }}</span
                >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </template>
    <template v-else-if="hasNextPage">
      <el-form
        v-show="isFirstPage"
        ref="ruleForm"
        :model="form"
        label-position="left"
        label-width="160px"
      >
        <el-form-item
          label="Advertiser"
          prop="advertiser"
          :rules="stringRule('advertiser')"
        >
          <el-select
            v-model="form.advertiser"
            @change="form.campaign = null"
            clearable
            popper-class="select-advertiser"
          >
            <el-option
              v-for="opt in advertiserOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
              :disabled="!opt.icon && disabledWithCreativeType"
            >
              <span class="option">
                <el-avatar v-if="opt.icon" :size="avatarSize" :fit="'fit'">
                  <img
                    :src="opt.icon"
                    :width="avatarSize"
                    :height="avatarSize"
                  />
                </el-avatar>
                <el-avatar
                  v-else
                  :size="avatarSize"
                  icon="el-icon-user-solid"
                  :fit="'scale-down'"
                >
                </el-avatar>
                <span class="option-label"> {{ opt.label }} </span>
                <span
                  v-if="!opt.icon && disabledWithCreativeType"
                  class="option-end"
                >
                  No Icon Available
                </span>
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Campaign"
          prop="campaign"
          :rules="stringRule('campaign')"
        >
          <el-select
            v-model="form.campaign"
            clearable
            :disabled="!form.advertiser"
          >
            <el-option
              v-for="opt in campaignOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Name" prop="name" :rules="stringRule('name')">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          v-if="[].includes(form._type)"
          label="Landing Page"
          prop="landing_page"
          :rules="
            urlRule(
              'landing_page',
              form._type != CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.OUTSTREAM
            )
          "
        >
          <el-input v-model="form.landing_page"></el-input>
        </el-form-item>
        <el-form-item
          label="Preview Type"
          prop="preview_type"
          :rules="optionRule('preview_type', previewOptions)"
          v-if="previewOptions.length"
        >
          <el-select v-model="form.preview_type">
            <el-option
              v-for="opt in previewOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Preview Mode" v-if="previewOptions.length">
          <el-radio-group text-color="#EF767A" v-model="form.preview_device">
            <el-radio-button :label="CONSTANT.PREVIEW_DEVICE.PC"
              >PC</el-radio-button
            >
            <el-radio-button :label="CONSTANT.PREVIEW_DEVICE.MOBILE"
              >MOBILE</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
      <component
        ref="typeField"
        :is="_.upperFirst(form._type + 'Form').replace('WithOutstream', '')"
        v-model="form"
        :currentPage="currentPage"
      >
      </component>
      <el-form v-show="isFirstPage">
        <template
          v-if="form._type !== CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.VAST"
        >
          <el-divider>
            <span class="blue">Base Trackings</span>
          </el-divider>
          <form-item-group
            title="Impression Trackings"
            :min="0"
            :max="5"
            v-model="form.impression_trackings"
          >
            <template slot-scope="{ index }">
              <el-form-item
                label="impression"
                :prop="`impression_trackings.${index}`"
                :rules="urlRule('impression_tracking')"
                label-width="120px"
              >
                <el-input v-model="form.impression_trackings[index]"></el-input>
              </el-form-item>
            </template>
          </form-item-group>

          <form-item-group
            title="Click Trackings"
            :min="0"
            :max="5"
            v-model="form.click_trackings"
          >
            <template slot-scope="{ index }">
              <el-form-item
                label="click"
                :prop="`click_trackings.${index}`"
                :rules="urlRule('click_trackings')"
                label-width="120px"
              >
                <el-input v-model="form.click_trackings[index]"></el-input>
              </el-form-item>
            </template>
          </form-item-group>

          <el-form-item label="Audience" prop="audience">
            <el-select v-model="form.audience" multiple clearable>
              <el-option
                v-for="opt in audienceOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              >
                <span style="float: left">{{ opt.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px"
                  >size: {{ opt.size }}</span
                >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </template>
    <template #footer-btn>
      <span v-if="!hasNextPage">
        <el-button
          class="btn btn-form btn-blue btn-footer"
          :disabled="isLoading"
          @click="submit()"
          >Submit</el-button
        >
        <el-button
          class="btn btn-form btn-pink btn-footer"
          @click="preview()"
          >{{ preview_window ? "Refresh" : "Preview" }}</el-button
        >
      </span>
      <span v-if="hasNextPage" style="display:flex;">
        <div v-if="!isFinalPage">
          <el-button
            class="btn btn-form btn-blue btn-footer"
            :disabled="isLoading"
            @click="nextPage()"
            >Next</el-button
          >
        </div>
        <div v-if="!isFirstPage">
          <el-button
            class="btn btn-form btn-gray btn-footer"
            :disabled="isLoading"
            @click="previousPage()"
            >Previous</el-button
          >
        </div>
        <div v-if="isFinalPage">
          <el-button
            class="btn btn-form btn-blue btn-footer"
            :disabled="isLoading"
            @click="submit()"
            >Submit</el-button
          >
          <el-button
            class="btn btn-form btn-pink btn-footer"
            @click="preview()"
            >{{ preview_window ? "Refresh" : "Preview" }}</el-button
          >
        </div>
      </span>
    </template>
  </custom-dialog>
</template>
<script>
import { mapState } from "vuex";
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
import CustomDialog from "@/components/base/customDialog";
import InskinForm from "@/components/base/forms/creatives/inskin.vue";
import OutstreamForm from "@/components/base/forms/creatives/outstream.vue";
import PushdownForm from "@/components/base/forms/creatives/pushdown.vue";
import ParallaxScrollingForm from "@/components/base/forms/creatives/parallaxScrolling.vue";
import ParallaxScrollingFlipForm from "@/components/base/forms/creatives/parallaxScrollingFlip.vue";
import ScrollingBoxForm from "@/components/base/forms/creatives/scrollingBox.vue";
import CarouselForm from "@/components/base/forms/creatives/carousel.vue";
import BannerForm from "@/components/base/forms/creatives/banner.vue";
import SpinnerForm from "@/components/base/forms/creatives/spinner.vue";
import CardsForm from "@/components/base/forms/creatives/cards.vue";
import RollingCastleForm from "@/components/base/forms/creatives/rollingCastle.vue";
import SwitchForm from "@/components/base/forms/creatives/switch.vue";
import MarqueeForm from "@/components/base/forms/creatives/marquee.vue";
import RotatingFerrisWheelForm from "@/components/base/forms/creatives/rotatingferriswheel.vue";
import SwapForm from "@/components/base/forms/creatives/swap.vue";
import CountDownForm from "@/components/base/forms/creatives/countDown.vue";
import VastForm from "@/components/base/forms/creatives/vast.vue";
import PostAdForm from "@/components/base/forms/creatives/postAd.vue";
import DataDrivenForm from "@/components/base/forms/creatives/dataDriven.vue";
const { DATA_DRIVEN } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      currentPage: 1,
      preview_window: null,
      isLoading: false,
      avatarSize: 35,
      form: {
        name: "",
        _type: CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.INSKIN,
        folder: undefined,
        advertiser: undefined,
        campaign: undefined,
        landing_page: "",
        audience: [],
        preview_type: CONSTANT.ENUM_PREVIEW_TYPE.HEADER,
        preview_device: CONSTANT.PREVIEW_DEVICE.PC,
      },
    };
  },
  components: {
    CustomDialog,
    InskinForm,
    OutstreamForm,
    PushdownForm,
    ParallaxScrollingForm,
    ParallaxScrollingFlipForm,
    ScrollingBoxForm,
    CarouselForm,
    BannerForm,
    SpinnerForm,
    CardsForm,
    RollingCastleForm,
    SwitchForm,
    MarqueeForm,
    RotatingFerrisWheelForm,
    SwapForm,
    CountDownForm,
    VastForm,
    PostAdForm,
    DataDrivenForm,
  },
  computed: {
    ...mapState({
      visible: (state) => state.isDialogVisible,
      typeMapping: (state) => state.creative.typeMapping,
      audienceOptions: (state) =>
        _.map(state.audience.audiences, (i) => ({
          label: i.name,
          value: i.audience_id,
          size: i.size,
        })),
      advertiserOptions: (state) =>
        _.map(state.advertiser.advertisers, (i) => ({
          label: i.name,
          value: i._id,
          campaigns: i.campaigns,
          icon: i.icon,
        })),
      assets: (state) => state.asset.assets,
    }),
    disabledWithCreativeType() {
      let types = [
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD_WITH_OUTSTREAM,
      ];
      return types.includes(this.row._type);
    },
    campaignOptions() {
      if (!this.form.advertiser) {
        return [];
      }
      const advertiser = _.find(
        this.advertiserOptions,
        (advertiser) => advertiser.value === this.form.advertiser
      );
      return advertiser
        ? _.map(advertiser.campaigns, (i) => ({
            label: i.name,
            value: i._id,
          }))
        : [];
    },
    previewMapping() {
      return Object.keys(CONSTANT.ENUM_PREVIEW_TYPE).reduce(
        (map, k) => ({
          ...map,
          [CONSTANT.ENUM_PREVIEW_TYPE[k]]: _.lowerCase(k),
        }),
        {}
      );
    },
    previewOptions() {
      let values = [];
      if (
        [
          CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER,
          CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER_WITH_OUTSTREAM,
          CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.DATA_DRIVEN,
        ].includes(this.row._type)
      ) {
        values = [0, 2, 7];
      }
      return values.map((v) => ({
        label: this.previewMapping[v],
        value: v,
      }));
    },
    hasNextPage() {
      const type = ["dataDriven"];
      return type.includes(this.row._type);
    },
    isFirstPage() {
      return this.currentPage === 1;
    },
    isFinalPage() {
      return this.currentPage === this.finalPage;
    },
    finalPage() {
      if (this.row._type === "dataDriven") {
        return DATA_DRIVEN.FINAL_PAGE;
      }
    },
  },
  async created() {
    this.initData();
    window.addEventListener("message", this.messageHandler, false);
  },
  mounted() {
    this.isMounted = true;
  },
  watch: {
    visible(newVisible) {
      if (newVisible) {
        this.initData();
      } else {
        const win = this.preview_window;
        if (win && !win.closed) {
          this.preview_window.close();
        }
      }
    },
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    nextPage() {
      this.currentPage++;
    },
    previousPage() {
      this.currentPage--;
    },
    initData() {
      this.preview_window = null;
      this.form = {
        name: "",
        _type:
          this.row._type || CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.INSKIN,
        folder: this.row.folder,
        advertiser: this.row.advertiser,
        campaign: this.row.campaign,
        landing_page: "",
        preview_type: this.row.preview_type,
        preview_device: this.row.preview_device || CONSTANT.PREVIEW_DEVICE.PC,
        impression_trackings: [],
        click_trackings: [],
        audience: [],
      };
      if (this.row._id && this.visible) this.setData();
    },
    async setData() {
      await this.$nextTick();
      this.form.advertiser = this.row.advertiser;
      this.form.campaign = this.row.campaign;

      this.form.name = this.row.name;
      this.form.landing_page = decodeURI(this.row.landing_page);
      this.form.audience = this.row.audience;
      this.form.impression_trackings = _.map(
        this.row.impression_trackings,
        (tracking) => decodeURI(tracking)
      );
      this.form.click_trackings = _.map(this.row.click_trackings, (tracking) =>
        decodeURI(tracking)
      );
      this.$refs.typeField.setData(this.row);
    },
    getValidateList(cmpts) {
      return _.reduce(
        cmpts,
        (map, cmpt) => {
          if (Array.isArray(cmpt)) {
            return [
              ...map,
              ...cmpt.reduce(
                (m, c) => [...m, ...this.getValidateList({ c })],
                []
              ),
            ];
          } else if (cmpt.validate) {
            return [...map, cmpt.validate()];
          } else if (cmpt.$refs) {
            return [...map, ...this.getValidateList(cmpt.$refs)];
          }
          return;
        },
        []
      );
    },
    async checkForm() {
      try {
        const valid = await Promise.all(this.getValidateList(this.$refs));
        if (valid.every(Boolean)) {
          let setObj = {
            name: this.form.name,
            _type: this.form._type,
            impression_trackings: _.map(
              this.form.impression_trackings,
              (tracking) => tracking.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c))
            ),
            click_trackings: _.map(this.form.click_trackings, (tracking) =>
              tracking.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c))
            ),
            audience: this.form.audience,
            advertiser: this.form.advertiser,
            campaign: this.form.campaign,
          };
          if (
            [
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.INSKIN,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.OUTSTREAM,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PUSHDOWN,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PUSHDOWN_WITH_OUTSTREAM,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PARALLAX_SCROLLING,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY
                .PARALLAX_SCROLLING_WITH_OUTSTREAM,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PARALLAX_SCROLLING_FLIP,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER_WITH_OUTSTREAM,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.MARQUEE,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.ROTATINGFERRISWHELL,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.COUNT_DOWN,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.VAST,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD_WITH_OUTSTREAM,
            ].includes(this.form._type)
          )
            setObj.landing_page = [
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.ROTATINGFERRISWHELL,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.VAST,
            ].includes(this.form._type)
              ? this.form.landing_page
              : this.form.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
          if (this.form.folder) setObj.folder = this.form.folder;
          if (
            [
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.BANNER_WITH_OUTSTREAM,
              CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.DATA_DRIVEN,
            ].includes(this.form._type)
          ) {
            setObj.preview_type = this.form.preview_type;
            setObj.preview_device = this.form.preview_device;
          }
          return await this.$refs.typeField.getData(setObj);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async submit() {
      try {
        this.isLoading = true;
        const setObj = await this.checkForm();
        if (setObj) {
          if (this.row._id) {
            await store.dispatch("creative/updateCreativeById", {
              id: this.row._id,
              setObj: setObj,
            });
          } else {
            await store.dispatch("creative/createCreative", setObj);
            const path = setObj.folder
              ? `/folder/${setObj.folder}`
              : `/creatives`;
            if (this.$route.path !== path) this.$router.push({ path: path });
          }
          this.$message({ message: "Success!", type: "success" });
          store.commit("setDialogVisible", false);
        }
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    setTempCreative(creative) {
      let command = {};
      command.type = "tempCreative";
      command.creative = creative;
      this.preview_window.postMessage(command, "*");
    },
    async preview() {
      try {
        const setObj = await this.checkForm();
        if (setObj) {
          let win = this.preview_window;
          if (!win || win.closed) {
            const route = this.$router.resolve({ path: "/preview/temp" });
            this.preview_window = win = window.open(route.href, "_blank");
            win.onload = () => {
              this.setTempCreative(setObj);
              win.focus();
            };
          } else {
            win.location.reload();
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async messageHandler(e) {
      switch (e.data.type) {
        case "temp":
          const setObj = await this.checkForm();
          if (setObj) {
            this.setTempCreative(setObj);
            this.preview_window.focus();
          }
          break;
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.selected
  display: none
.select-advertiser
  .el-select-dropdown__item
    height: 45px
  .option
    height: 45px
    display: flex
    align-items: center
    &-label
      margin-left: 8px
    &-end
      margin-left: auto
</style>
